import React from "react";
import { useLanguage } from "./LanguageContext";
import "./LanguageSwitch.scss";

const LanguageSwitch = ({ className = "" }) => {
  const { lang, setLang } = useLanguage();

  return (
    <div className={`lang-switch ${className}`} role="group" aria-label="Language / ენა">
      <button
        type="button"
        className={lang === "ka" ? "active" : ""}
        onClick={() => setLang("ka")}
        aria-pressed={lang === "ka"}
      >
        ქარ
      </button>
      <button
        type="button"
        className={lang === "en" ? "active" : ""}
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitch;
